import {createAsyncThunk} from '@reduxjs/toolkit';
import {SurveyId, SurveyValues} from 'common/models/survey';
import {Success} from 'ui/../common/models/success';
import withAbortRequest from 'ui/store/utils/withAbortRequest';
import {sdk} from 'ui/utils/sdk';

import {prepareSuccessAction} from '../../success/actions/prepareSuccess';
import {AsyncThunkConfig} from '../survey.types';

interface PrepareSurvey {
    surveyId: SurveyId;
    values: SurveyValues;
    parent: string;
    key?: string;
    dryRun?: boolean;
}

const postSurvey = createAsyncThunk<void | Success, PrepareSurvey, AsyncThunkConfig<Success>>(
    'postSurvey',
    ({surveyId, values, parent, key, dryRun}, {signal, dispatch, rejectWithValue}) => {
        return withAbortRequest(
            sdk.form.postSurvey({surveyId, values, parent, key, dryRun}).then((success) => {
                dispatch(prepareSuccessAction(success));
                return success;
            }),
            signal,
        ).catch((error) => {
            return rejectWithValue(error);
        });
    },
);

export default postSurvey;
